import React from "react";

const OrderList = React.lazy(() => import("./OrderList"));

export default {
  list: OrderList,
};
